import React__default from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint.js';

const BreakPointItem = ({ children, min, max, includeMin = false, includeMax = false, visibleOnInit = true }) => {
    const show = useBreakpoint({ min, max, includeMin, includeMax, visibleOnInit });
    return show ? React__default.createElement(React__default.Fragment, null, children) : null;
};

export { BreakPointItem };
//# sourceMappingURL=index.js.map
